import { defineComponent as _defineComponent } from 'vue'
import { EventDB } from '@/enitites/event'
import { EventPreviewBaseCard } from '@/features/event-card'

interface IProps {
  events: EventDB[]
  searchParamsTab: boolean
  isNotFound: boolean
  infiniteId: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EventsGridPage',
  props: {
    events: null,
    searchParamsTab: { type: Boolean },
    isNotFound: { type: Boolean },
    infiniteId: null
  },
  emits: ["infinite"],
  setup(__props: any, { emit }: { emit: ({ (e: 'infinite', value: unknown): void }), expose: any, slots: any, attrs: any }) {





function infiniteHandler($state: unknown) {
  emit('infinite', $state)
}

return { __sfc: true,emit, infiniteHandler, EventPreviewBaseCard }
}

})